import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex text-gray-800 align-items-center" }

import { toRefs } from 'vue';
import { EMIT } from '@/enum';

interface PropsInterface {
  open: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CancelWorkflowDialog',
  props: {
    open: { type: Boolean }
  },
  emits: [EMIT.CANCEL, EMIT.UPDATE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const { open } = toRefs(props);

const onCancel = () => emit(EMIT.CANCEL);

const onApprove = () => emit(EMIT.UPDATE);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(open))
      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
          key: 0,
          header: "Cancel Referral Workflow",
          "accept-label": "Yes",
          "reject-label": "No",
          onAccept: onApprove,
          onCancel: onCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Icon, {
                name: "warning",
                class: "confirm-dialog-icon text-gray-600"
              }),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ml-3" }, [
                _createTextVNode(" Are you sure you want to cancel out of the Referral Workflow? "),
                _createElementVNode("strong", { class: "text-color-alert" }, "All unprocessed changes will be lost.")
              ], -1))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})